module.exports = __webpack_public_path__ + "img/error.1cae8660.png";